export const hdeCASEMapping = [
    {
        id: 'case_id',
        label: 'Case ID',
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'first_name',
        label: 'First Name',
    },
    {
        id: 'middle_name',
        label: 'Middle Name',
    },
    {
        id: 'last_name',
        label: 'Last Name',
    },
    {
        id: 'date_of_birth',
        label: 'Date of Birth',
    },
    {
        id: 'date_of_death',
        label: 'Date of Death',
    },
    {
        id: 'time_of_death',
        label: 'Time of Death',
    },
    {
        id: 'home_address',
        label: 'Home Address',
    },
    {
        id: 'zip',
        label: 'Zip Code',
    },
    {
        id: 'country',
        label: 'Country',
    },
    {
        id: 'age',
        label: 'Age',
    },
    {
        id: 'sex',
        label: 'Sex',
    },
    {
        id: 'gender_identity',
        label: 'Gender Identity',
    },
    {
        id: 'ethnicity',
        label: 'Ethnicity',
    },
    {
        id: 'height',
        label: 'Height',
    },
    {
        id: 'weight',
        label: 'Weight',
    },
    {
        id: 'treatment_location',
        label: 'Treatment Location',
    },
    {
        id: 'physician',
        label: 'Physician',
    },
    {
        id: 'route_to_diagnosis',
        label: 'Route to Diagnosis',
    },
    {
        id: 'registration_date',
        label: 'Registration Date',
    },
    {
        id: 'diagnostic_tests',
        label: 'Diagnostic Tests',
    },
    {
        id: 'diagnostics_start_date',
        label: 'Diagnostics Start Date',
    },
    {
        id: 'diagnosis_date',
        label: 'Diagnosis Date',
    },
    {
        id: 'diagnosis',
        label: 'Diagnosis',
    },
    {
        id: 'cancer_type',
        label: 'Cancer Type',
    },
    {
        id: 'cancer_sub_type',
        label: 'Cancer Sub Type',
    },
    {
        id: 'icd10_code',
        label: 'ICD10 Code',
    },
    {
        id: 'gene_mutations',
        label: 'Gene Mutations',
    },
    {
        id: 'tumor_areas',
        label: 'Tumor Areas',
    },
    {
        id: 'clinical_stage',
        label: 'Clinical Stage',
    },
    {
        id: 'response_to_treatment',
        label: 'Response to Treatment',
    },
    {
        id: 'other_conditions',
        label: 'Other Conditions',
    },
    {
        id: 'treatment_procedure',
        label: 'Treatment Procedure',
    },
    {
        id: 'treatment_planning_finish_date',
        label: 'Treatment Planning Finish Date',
    },
    {
        id: 'treatment_procedure_start_date',
        label: 'Treatment Procedure Start Date',
    },
    {
        id: 'treatment_procedure_finish_date',
        label: 'Treatment Procedure Finish Date',
    },
    {
        id: 'drug_treatment',
        label: 'Drug Treatment',
    },
    {
        id: 'drug_treatment_start_date',
        label: 'Drug Treatment Start Date',
    },
    {
        id: 'drug_treatment_finish_date',
        label: 'Drug Treatment Finish Date',
    },
    {
        id: 'trial_participation',
        label: 'Trial Participation',
    },
    {
        id: 'trial_id',
        label: 'Trial ID',
    },
    {
        id: 'post_treatment_surveillance',
        label: 'Post Treatment Surveillance',
    },
];
